import { useEffect, useState } from "react";
import { X, Megaphone } from "lucide-react";
import api from "@/lib/api";

const STORAGE_KEY = "clbc_dismissed_announcement_id";

export default function AnnouncementBanner() {
  const [ann, setAnn] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await api.get("/announcements");
        if (cancelled) return;
        const active = (data || []).find((a) => a.active) || null;
        setAnn(active);
        if (active) {
          const last = localStorage.getItem(STORAGE_KEY);
          setDismissed(last === active.id);
        }
      } catch (e) {
        // silent
      }
    };
    load();
    const t = setInterval(load, 60000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (!ann || dismissed) return null;

  const close = () => {
    localStorage.setItem(STORAGE_KEY, ann.id);
    setDismissed(true);
  };

  return (
    <div
      data-testid="announcement-banner"
      className="relative bg-gradient-to-r from-royal via-royal-800 to-royal text-white"
    >
      <div className="container-x py-3 flex items-center gap-4">
        <div className="hidden sm:flex w-9 h-9 rounded-full bg-gold/20 items-center justify-center shrink-0">
          <Megaphone className="w-4 h-4 text-gold" />
        </div>
        <div className="flex-1 min-w-0 text-sm">
          <span className="font-semibold text-gold tracking-wide uppercase text-[11px] mr-3">
            {ann.title}
          </span>
          <span className="text-white/90">{ann.body}</span>
        </div>
        <button
          type="button"
          onClick={close}
          aria-label="Dismiss"
          data-testid="announcement-dismiss"
          className="shrink-0 w-8 h-8 rounded-full hover:bg-white/10 transition-colors flex items-center justify-center"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
